import { API } from "@/services"

export const SERVERS_ENDPOINTS = {
  create(data={}){
    return API.Axios.automation.v1.request({
      url: `servers`,
      method: 'POST',
      data,
    })
  },
  list(params={}){
    return API.Axios.automation.v1.request({
      url: `servers`,
      method: 'GET',
      params,
    })
  },
  findById(id='',params={}){
    return API.Axios.automation.v1.request({
      url: `servers/${id}`,
      method: 'GET',
      params,
    })
  },
  delete(id='',data={}){
    return API.Axios.automation.v1.request({
      url: `servers/${id}`,
      method: 'DELETE',
      data,
    })
  },
  update(id='',data={}){
    return API.Axios.automation.v1.request({
      url: `servers/${id}`,
      method: 'PUT',
      data,
    })
  },
}